import {
  MANUAL_BOOKING_APPROVAL,
  MANUAL_BOOKING_APPROVAL_SUCCESS,
  MANUAL_BOOKING_APPROVAL_ERROR,
  MANUAL_BOOKING_APPROVAL_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ManualBookingApproval = (state = initialState, action) => {
  switch (action.type) {
    case MANUAL_BOOKING_APPROVAL:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case MANUAL_BOOKING_APPROVAL_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case MANUAL_BOOKING_APPROVAL_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case MANUAL_BOOKING_APPROVAL_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ManualBookingApproval;
